import { FunctionComponent } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import classnames from 'classnames';

import { Routes } from 'types/routes';

import { withVariables } from 'utils/string';

import Slick from 'components/layout/Slick';

import { Props } from './index';
import StyledComponent from './styles';

const PublicLayoutFaqCategories: FunctionComponent<Props> = ({
    categories,
    activeCategorySlug,
}) => {
    const router = useRouter();

    const settings = {
        arrows: true,
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        fade: false,
        infinite: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                },
            },
        ],
    };
    return (
        <StyledComponent>
            <aside className="categories-container">
                <ul className="categories-list">
                    {categories.map(category => (
                        <li
                            key={category.id}
                            className={classnames(
                                'category',
                                { 'active': category.slug === activeCategorySlug }
                            )}
                        >
                            <Link
                                href={{
                                    pathname: category.slug === 'warto-wiedziec' ? Routes.PublicBlog : Routes.PublicFaqCategory,
                                    query: category.slug === 'warto-wiedziec' ? '' : { slug: category.slug },
                                }}
                                prefetch={false}
                            >
                                <a className="categories-link">
                                    {category.name}
                                </a>
                            </Link>
                        </li>
                    ))}
                </ul>
            </aside>

            <aside className="categories-container-mobile">
                <ul className="categories-list-mobile">
                    <Slick sliderProps={{
                        ...settings,
                        initialSlide: categories.findIndex(({ slug }) => slug === activeCategorySlug),
                        afterChange: (currenSlideIndex) => router.push(withVariables(Routes.PublicFaqCategory, { slug: categories[currenSlideIndex].slug })),
                    }}
                    >
                        {categories.map(category => (
                            <li
                                key={category.id}
                                className={classnames(
                                    'category-mobile',
                                    { 'active': category.slug === activeCategorySlug }
                                )}
                            >
                                <Link
                                    href={{
                                        pathname: Routes.PublicFaqCategory,
                                        query: { slug: category.slug },
                                    }}
                                    prefetch={false}
                                >
                                    <a className="categories-link-mobile">
                                        {category.name}
                                    </a>
                                </Link>
                            </li>
                        ))}
                    </Slick>
                </ul>
            </aside>
        </StyledComponent>
    );
};

export default PublicLayoutFaqCategories;